import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { installAnalytics } from "./analytics";
import { resolveEntryLocale } from "./i18n/routes";
import { LandingPage } from "./pages/LandingPage";
import { LegalPage } from "./pages/LegalPage";
import { SupportPage } from "./pages/SupportPage";

function getBasename() {
  const base = import.meta.env.BASE_URL || "/";
  return base === "/" ? "/" : base.replace(/\/$/, "");
}

function EntryRoute() {
  const locale = resolveEntryLocale();
  if (locale === "zh") return <Navigate to="/zh" replace />;
  return <LandingPage locale="en" />;
}

export function App() {
  useEffect(() => {
    installAnalytics();
  }, []);

  return (
    <BrowserRouter basename={getBasename()}>
      <Routes>
        <Route path="/" element={<EntryRoute />} />
        <Route path="/privacy" element={<LegalPage locale="en" kind="privacy" />} />
        <Route path="/terms" element={<LegalPage locale="en" kind="terms" />} />
        <Route path="/support" element={<SupportPage locale="en" />} />
        <Route path="/zh" element={<LandingPage locale="zh" />} />
        <Route path="/zh/privacy" element={<LegalPage locale="zh" kind="privacy" />} />
        <Route path="/zh/terms" element={<LegalPage locale="zh" kind="terms" />} />
        <Route path="/zh/support" element={<SupportPage locale="zh" />} />
        <Route path="/en" element={<Navigate to="/" replace />} />
        <Route path="/en/privacy" element={<Navigate to="/privacy" replace />} />
        <Route path="/en/terms" element={<Navigate to="/terms" replace />} />
        <Route path="/en/support" element={<Navigate to="/support" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
